<template>
  <div class="flex items-end justify-between border-b">
    <div class="flex items-center">
      <lf-tab
        v-for="tab in tabs"
        :key="tab.id"
        :data-cy="`tab-${tab.name}`"
        :active="activeTab === tab.id"
        @click="handleActiveTabChange(tab.id)"
      >
        <div
          class="text-headline"
          :class="{ 'font-bold': activeTab === tab.id }"
        >
          {{ tab.name }}
        </div>
      </lf-tab>
    </div>
    <type-filter class="ml-auto" @value:changed="handleTypeFilterChange" />
  </div>
</template>
<script setup lang="ts">
import { ref } from "vue";
import { useI18n } from "vue-i18n";

import { NoteTab } from "@/enums/communicationLogs";

import TypeFilter from "@/components/deals/dealActivity/notes/TypeFilter.vue";
import LfTab from "@/components/ui/LfTab.vue";

import type { NoteType } from "@/enums/dealActivity";

const emit = defineEmits<{
  "tab:changed": [NoteTab];
  "type:changed": [NoteType | undefined];
}>();

const { t } = useI18n();

const activeTab = ref<NoteTab>(NoteTab.All);

const tabs: { id: NoteTab; name: string }[] = [
  {
    id: NoteTab.All,
    name: t("COMMON.ALL"),
  },
  {
    id: NoteTab.Recent,
    name: t("COMMON.RECENT"),
  },
  {
    id: NoteTab.Pinned,
    name: t("COMMON.PIN", 2),
  },
];

const handleActiveTabChange = (tabId: NoteTab) => {
  activeTab.value = tabId;
  emit("tab:changed", tabId);
};

const handleTypeFilterChange = (type: NoteType[]) => {
  emit("type:changed", type?.[0]);
};
</script>
